export const MIN_COMPOSER_HEIGHT = 41;
export const MAX_COMPOSER_HEIGHT = 41;
export const DEFAULT_PLACEHOLDER = "Type a message...";
export const DATE_FORMAT = "ll";
export const TIME_FORMAT = "LT";
export const MSG_TYPE_TEXT = "text";
export const MSG_TYPE_EMOJI = "emoji";
export const MSG_TYPE_IMG = "image";
